import React, { useEffect, useState } from 'react'

import NoResultsInfo from './NoResultsInfo'
import TrendingSlider from './TrendingSlider'
import { fromServerToClient } from '../../../lib/utils/collection'
import transport from '../../../lib/services/transport'
import { rootStoreInstance } from '../SearchBar/stores'

const SearchResultsEmptyState = () => {
  const [isLoading, setLoading] = useState(false)
  const [listings, setListings] = useState([])

  const { listingTypeStore: { current, listingTypes } } = rootStoreInstance
  const trendingUrl = listingTypes[current]?.trendingUrl

  useEffect(() => {
    let isMounted = true

    const fetchData = async () => {
      if (!isMounted) {return}
      setLoading(true)

      try {
        const response = await transport.Listing.getTrandingNowListings(trendingUrl)
        const { data } = fromServerToClient(response)

        if (isMounted) {
          setListings(data)
        }
      } finally {
        if (isMounted) {
          setLoading(false)
        }
      }
    }

    fetchData()

    return () => {
      isMounted = false
    }
  }, [trendingUrl])

  const markListingAsSaved = savedListingId => {
    setListings(prevListings =>
      prevListings.map(listing =>
        listing.id === savedListingId ? { ...listing, saved: !listing.saved } : listing
      )
    )
  }

  return (
    <div className='SearchResultsEmptyState'>
      <NoResultsInfo />
      <section
        className='SearchResultsEmptyState-trendingSliderWrapper'
        aria-label='Trending Now'
        aria-roledescription='carousel'
      >
        <h2 className='SearchResultsEmptyState-headline'>Trending Now</h2>
        <div className='SearchResultsEmptyState-trendingSlider'>
          <TrendingSlider listings={listings} markListingAsSaved={markListingAsSaved} isLoading={isLoading} />
        </div>
      </section>
    </div>
  )
}

export default SearchResultsEmptyState
